import { createRenderBatcher } from './basler-components.es777.js';
import { noop } from './basler-components.es725.js';

const { schedule: frame, cancel: cancelFrame, state: frameData} = /* @__PURE__ */ createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);

export { cancelFrame, frame, frameData };
